import React, {PureComponent} from "react";

import {ScenarioContentBlockInfo} from "./scenario-parameter-block-persons";
import style from "./style.module.css";
import {Icon, IconLabel} from "../icon/index";
import {IconMask} from "../icon/with-mask";
import {createIconUrl, mapRange} from "../../utils";


const createBlockContent = (records, valueToMatch) => {
  let index = records.findIndex(record => record.labels_value === valueToMatch);
  let error = false;
  if(index=== -1 || valueToMatch === "null"){
    index = 0;
    error = true;
  }

  return {
    index,
    error,
    content: records[index],
  }
};


export class ScenarioContent extends PureComponent {
  render() {
    const {data, sliderColor, theme, staticContent, themeName} = this.props;



    const trafficContent= createBlockContent(staticContent.traffic_guidance, data.traffic_guidance);
    const distanceContent = createBlockContent(staticContent.distance_person, data.distance_person);
    const personContent =  staticContent.persons_vehicle[0];

    return (
        <div className={style.wrapper}>
          <div className={`${style.infos} ${style.row}`}>
            <ScenarioContentBlockInfo title={personContent.title}
                                      text={personContent.description}
                                      theme={theme}
                                      themeName={themeName}
            />
            <ScenarioContentBlockInfo title={distanceContent.content.title}
                                      text={distanceContent.content.description}
                                      theme={theme}
                                      themeName={themeName}
            />
            <ScenarioContentBlockInfo title={trafficContent.content.title}
                                      text={trafficContent.content.description}
                                      theme={theme}
                                      themeName={themeName}
            />
          </div>

          <div className={`${style.icons} ${style.row}`}>
            <div className={style.contentBlock}>
              <IconMask path={createIconUrl(personContent)}
                        value={mapRange(data.persons_vehicle, 0, 2, 0, 100)}
                        iconColor={sliderColor}
                        label={null}
                        className={style.icon}
                        backgroundColor={theme.iconBackground}
              />
            </div>
            <div className={`${style.contentBlock} ${distanceContent.error?style.error:""}`}>
              <Icon path={createIconUrl(distanceContent.content)}
                    currentIndex={distanceContent.index}
                    iconColor={sliderColor}
                    className={style.icon}
                    label={null}
                    backgroundColor={theme.iconBackground}
              />
            </div>
            <div className={`${style.contentBlock} ${trafficContent.error?style.error:""}`}>
              <Icon path={createIconUrl(trafficContent.content)}
                    currentIndex={trafficContent.index}
                    iconColor={sliderColor}
                    label={null}
                    className={style.icon}
                    backgroundColor={theme.iconBackground}
              />
            </div>
          </div>

          <div className={`${style.labels} ${style.row}`}>
            <IconLabel color={sliderColor}
                       label={data.persons_vehicle}
            />
            <IconLabel color={sliderColor}
                       label={distanceContent.error? "-": distanceContent.content.labels_label}
            />
            <IconLabel color={sliderColor}
                       label={trafficContent.error? "-": trafficContent.content.labels_label}
            />
          </div>
        </div>
    )
  }
}






// WEBPACK FOOTER //
// ./src/components/scenario-content/index.js